import type { RouteRecordRaw } from 'vue-router';
import { gdprRoutes } from './gdpr.routes';

export const sharedRoutes: RouteRecordRaw[] = [
  // Where the payment gateway returns a client who paid a receipt with no visit - a ticket or a
  // subscription. Those have no reservation to show, so they cannot use the 4-step confirmation.
  // Shared rather than subdomain-only on purpose: the link is opened from an email, and a failed
  // subdomain lookup must not turn it into a 404. The backend builds this url in
  // `get_receipt_payment_result_url_for_company` - the path must stay in sync with it.
  // Not `/payment`: that path is already the tenant's own subscription billing tree in
  // `routesMain`, and shared routes are appended to it.
  {
    path: '/payment-result',
    component: () => import('layouts/PaymentResultLayout.vue'),
    meta: {
      public: true,
    },
    children: [
      {
        // The id is not read by the page - the gateway's `payment_status` is the only signal it
        // has. It stays in the url so a receipt detail can be added later without the backend
        // having to change the url it already sent out by email.
        path: ':receipt_id',
        name: 'payment-result',
        component: () => import('pages/payment/PaymentResultPage.vue'),
      },
    ],
  },
  ...gdprRoutes,
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { public: true },
    component: () => import('pages/MaintenancePage.vue'),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    name: 'error-not-found',
    meta: { public: true },
    component: () => import('pages/ErrorNotFound.vue'),
  },
];
